/* Copyright 2013 - 2024 Waiterio LLC */
export default ({ date, locale }) =>
  new Date(date).toLocaleString(locale, { dateStyle: 'long' })
